// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"199":"ada6f968","271":"01179c61","413":"1f473188","684":"db85303c","717":"0a13a6fb"}[chunkId] + ".js";
};